var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoreSocials(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 26.073V22.24c-5.004 0-8.298 1.488-10.8 4.76 1.008-4.672 3.798-9.328 10.8-10.273V13l7.2 6.527-7.2 6.546z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNMjEuOCAyNi4wNzI1VjIyLjI0QzE2Ljc5NiAyMi4yNCAxMy41MDIgMjMuNzI3NSAxMSAyN0MxMi4wMDggMjIuMzI3NSAxNC43OTggMTcuNjcyNSAyMS44IDE2LjcyNzVWMTNMMjkgMTkuNTI3NUwyMS44IDI2LjA3MjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgMoreSocials as ReactComponent };